import { JSX } from 'react';
import { type IOrGenericContentProps } from './or-generic-content.types';
import { RenderRichText } from '@/components/helpers/cms/RenderRichText';
import { orGenericContentVariants } from './or-generic-content.variants.ts';
import classNames from 'classnames';

export const OrGenericContent = ({
  top_spacing,
  bottom_spacing,
  rich_text,
}: IOrGenericContentProps): JSX.Element => {
  const variantClasses = orGenericContentVariants({
    top_spacing,
    bottom_spacing,
  });
  return (
    <div className="container">
      <div className={classNames('w-full', variantClasses)}>
        <RenderRichText body={rich_text} />
      </div>
    </div>
  );
};
